import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import PainelDeAdmin from '../../../assets/svg/painel_de_admin.svg';
import './adminconsole.css';
import { useProfile } from "../../../context/ProfileProvider/useProfile";

export const AdminConsolePanel = () => {
    const { t } = useTranslation();
    const profile = useProfile();

    return (
        <Box sx={{
            borderRadius: '10px',
            border: '1px solid #0000001A',
            display: 'flex',
            backgroundColor: '#fff',
            height: 'fit-content',
        }}>
            <Box sx={{
                paddingTop: '20px',
                paddingBottom: '10px',
                paddingLeft: '20px',
                paddingRight: '20px',
                backgroundColor: '#E8EFF3',
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
            }}>
                <Box component="img" src={PainelDeAdmin} sx={{
                    width: '168px',
                    height: '98px',
                }} />
            </Box>
            <Box sx={{
                padding: '30px',
                backgrounColor: '#FFFFFF',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
            }}>
                <Typography sx={{
                    font: 'normal normal normal 20px/20px Segoe UI',
                    color: '#2D2D2D',
                }}>{t("AdminConsole.Hello")}<span style={{ font: 'font: normal normal 600 20px/20px Segoe UI', fontWeight: 'bold', color: '#2D2D2D' }}> {profile.name}!</span></Typography>
                <Typography sx={{
                    font: 'normal normal normal 16px/22px Segoe UI',
                    color: '#2D2D2D',
                }}>{t("AdminConsole.HereYouHaveAccessToYour")}<span style={{ font: 'normal normal 600 16px/22px Segoe UI', fontWeight: 'bold', color: '#2D2D2D' }}>{t("AdminConsole.AdminPanel")}</span>{t("AdminConsole.YouWillFindAllTheToolsYouNeedToManageYourSubscription")}</Typography>
            </Box>
        </Box>
    )
}

